module.exports = __webpack_public_path__ + "static/media/aws-logo.2e1e1f5d.ico";


//////////////////
// WEBPACK FOOTER
// ./src/aws-logo.ico
// module id = 60
// module chunks = 0